
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style scoped>
	/* コース別オプション条件マスタがあるレコード　*/
	.rkopListOn {

	}

	/* コース別オプション条件マスタがないレコード */
	.rkopListOff {
			background-color: yellow
	}

	/* 編集中のレコード */
	.rkopListEdit {
		background-color: red
	}
</style>
<template>
	<div class="contents" id="wirks">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>コース毎　オプション条件マスタ</h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>

			<!-- ▽  -->
			<section class="inputArea">

				<table class="inputTbl" id="krkop">
					<caption>
						<ul class="listClass">
							<li><b>クライアント</b>{{jgnm}}</li>
							<li><b>年度</b>{{nend}}</li>
							<li><b>コース</b>{{ksnm}}</li>
						</ul>
				<!--クライアントプルダウン-->
					<div class="listUp">
						<b>対象者区分</b>
							<select v-model="hfkb">
								<option v-for="item in listHfkb" v-bind:value="item.hfkb" v-bind:key="item.hfkb">
									{{item.kbnm}}
								</option>
							</select>
						<button class="confBtn" v-on:click="onSearch">検索</button>
						</div>
						<div class="btnLst">
							<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>        
							<!-- ↑ contntMenu「戻る」に変更 <button class="cancelBtn" v-on:click="onCancel">キャンセル</button>    -->   
						</div>

					</caption>
					<thead>
						<tr>
							<th colspan="2">オプション</th>
							<td>性別</td>
							<td>年齢範囲</td>
							<td>本体価格</td>
							<td></td>
              <td></td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(list, index) in listRkop" v-bind:key="list.recordDisplayKeyCount" v-bind:class="getClassNameByRecordStatuses(index)">
							<th>{{list.brnm}}</th>
							<th>{{list.opnm}}</th>
							<td>
								<select v-model="list.sex" v-on:change="changeRecord(index)">
									<option value="0">選択してください</option>
									<option v-for="item in listSex" v-bind:value="item.code" v-bind:key="item.code">
										{{item.name}}
									</option>
								</select>
							<td class="old">
								<input type="text" maxlength="3" placeholder="XXX" v-model="list.stag" v-on:change="changeRecord(index)"> ～ <input type="text" maxlength="3" placeholder="XXX" v-model="list.edag" v-on:change="changeRecord(index)">
							</td>
							<td class="fee">
								<input type="text" maxlength="6" placeholder="XXXXXX" v-model="list.kngk" v-on:change="changeRecord(index)">
							</td>
							<td class="btnLst">
                <div v-if="list.recordStatus == '1' || list.recordStatus == '13'">
                  <button class="dltBtn" v-on:click="onDeleteLocalRecord(index)">削除</button>
                </div>
								<div v-else>
									<button class="dltBtn" v-on:click="onConfirmDeleteModalOpen(index)">削除</button>
								</div>
							</td>
              <td class="btnLst">
                <div v-if="list.recordStatus != '1'">
                  <button class="confBtn" v-on:click="onAppendRecord(index)">追加</button>
                </div>
              </td>
						</tr>
					</tbody>
				</table>
				<!--データが一件もない場合に表示-->
				<div v-if="listRkop.length == 0">
					<p>データが一件も登録されていません。</p>
				</div>
			</section>
		<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmDelete.isShow" v-on:close="onConfirmDeleteModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmDelete.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onDelete">OK</button></li>
					<li><button v-on:click="onConfirmDeleteModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { WRKOPApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'
  import * as _ from 'lodash'

export default {
		// モジュール名
		name: 'MasterWRKOP',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow,
		},
		// データ
		data() {
			return {
				// クライアント名
				jgnm: '',
				// 年度
				nend: 0,
				// コース名
				ksnm: '',

				// 対象者区分
				hfkb: '',

				// 対象者区分プルダウン作成用リスト
				// hfkb: 対象者区分コード
				// kbnm: 名称
				listHfkb: [],

				// 性別プルダウン作成用リスト
				// code: コード値
				// name: 性別名
				listSex: [
					{ code:'Z', name:'共通' },
					{ code:'1', name:'男性' },
					{ code:'2', name:'女性' },
				],

				// コース毎オプション条件リスト
				// brnm: オプション分類名称
				// opbr: オプション分類コード
				// opnm: オプション項目名称
				// opcd: オプション項目コード
				// jkcd: 条件コード
				// sex:  性別
				// stag: 開始年齢
				// edag: 終了年齢
				// kngk: 合計金額
				// recordStatus:レコードステータス
				// 0: WRKOP（コース毎オプション条件）がともに存在する
				// 1: WRKOP（コース毎オプション条件）は存在しない
				// 12: WRKOP（コース毎オプション条件）が存在する時、
				//     画面で更新する場合
				// 13: WRKOP（コース毎オプション条件）が存在しない時、
				//     画面でレコードを追加する場合
				listRkop: [],

				// 削除レコード識別用条件コード
				deleteRecordIndex: 0,

				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
					confirmDelete: {
						messages: [
							'削除しますか？'
						],
						isShow: false
					},
				}
			}
		},
		// ライフサイクルハック　初期化
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWRKOP::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('MasterWRKOP::created End')
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog("MasterWRKOP::firstDisplay Start")

				// 非同期通信
				WRKOPApi.FirstDisplay({
					token: this.$store.state.auth.token,
					nend: this.$store.state.adminUserChoice.MasterWIRKS.nend,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd,
					kscd: this.$store.state.adminUserChoice.MasterWIRKS.kscd,
					key: this.$store.state.adminUserChoice.MasterWIRKS.key,
					hfkb: this.hfkb
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.jgnm = responce.data.jgnm
						this.nend = this.$store.state.adminUserChoice.MasterWIRKS.nend
						this.ksnm = responce.data.ksnm

						// 対象者区分はZ:共通を設定
						this.hfkb = 'Z'

						// 対象者区分プルダウン作成用リスト
						this.listHfkb = []
						// 最初に'Z':共通
						this.listHfkb.push({
							hfkb: 'Z',
							kbnm: '共通'
						})
						// レスポンスからデータを挿入
						responce.data.listHfkb.forEach(item =>{
							this.listHfkb.push(item)
						})

						// コース毎オプション条件リスト
						this.listRkop = responce.data.listRkop
            this.sortListRkop()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWRKOP::firstDisplay End')
				})
			},
      // 追加ボタン
      onAppendRecord: function (index) {
        UtilityConsoleLog.consoleLog('MasterWRKOP::onAppendRecord Start')

        const lastIndex = this.listRkop.length
        const newRkopRecord = _.clone(this.listRkop[index])

        newRkopRecord.jkcd  = '00'
        newRkopRecord.sex  = this.listRkop[index].sex
        newRkopRecord.stag = this.listRkop[index].stag
        newRkopRecord.edag = this.listRkop[index].edag
        newRkopRecord.kngk = this.listRkop[index].kngk
        newRkopRecord.recordDisplayKey = lastIndex
        newRkopRecord.recordStatus = '1'

        this.listRkop.splice(index + 1, 0, newRkopRecord)
        UtilityConsoleLog.consoleLog('this.listRkop')
        UtilityConsoleLog.consoleLog(this.listRkop)

        UtilityConsoleLog.consoleLog('MasterWRKOP::onAppendRecord End')
      },
      // 追加ボタンで追加された行の削除(DB反映前の行)
      onDeleteLocalRecord: function(index) {
        UtilityConsoleLog.consoleLog('MasterWRKOP::onDeleteLocalRecord Start')

        this.listRkop.splice(index, 1)

        UtilityConsoleLog.consoleLog('MasterWRKOP::onDeleteLocalRecord End')
      },
			// 検索
			onSearch: function() {
				UtilityConsoleLog.consoleLog("MasterWRKOP::Search Start")

				// 非同期通信
				WRKOPApi.Search({
					token: this.$store.state.auth.token,
					nend: this.$store.state.adminUserChoice.MasterWIRKS.nend,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd,
					kscd: this.$store.state.adminUserChoice.MasterWIRKS.kscd,
					key: this.$store.state.adminUserChoice.MasterWIRKS.key,
					hfkb: this.hfkb
				}).then(({ responce }) => {
					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// コース毎オプションリスト再取得
						this.listRkop = responce.data.listRkop
            this.sortListRkop()
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWRKOP::Search End')
				})
			},
			// 更新
			onUpdate: function() {

				UtilityConsoleLog.consoleLog("MasterWRKOP::onUpdate Start")

				// 非同期通信
				WRKOPApi.Update({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					key: this.$store.state.adminUserChoice.MasterWIRKS.key,
					hfkb: this.hfkb,
					opbrs: this.getOpbrs(),
					opcds: this.getOpcds(),
					jkcds: this.getJkcds(),
					sexes: this.getSexes(),
					stags: this.getStags(),
					edags: this.getEdags(),
					kngks: this.getKngks(),
					recordStatuses: this.getRecordStatuses()
				}).then(({ responce }) => {

						if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

							// 更新確認モーダルを閉じる
							this.onConfirmUpdateModalClose()
							// コース毎オプションリスト再取得
							this.listRkop = responce.data.listRkop
              this.sortListRkop()
						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
							this.onValidationErrorModalOpen(responce.data.errorMessagesList)
						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {
							this.onValidationErrorModalOpen(responce.data.errorMessagesList)
						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
						}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWRKOP::onUpdate End')
				})
			},
			// 削除
			onDelete: function() {

				UtilityConsoleLog.consoleLog("MasterWRKOP::onDelete Start")

				// recordStatus：13 画面で追加したレコードの場合
				// 0: DBにデータ有りの状態、DBデータ削除
				// 1: 画面にもDBにもデータなしの状態、
				//    削除ボタン非活性となりそもそもこの処理は通らない
				// 12: DBにデータ有りの状態、DBデータ削除
				// 13: 画面にのみデータ有り、画面の該当レコードを
				//     初期化（データなしの初期状態）する
				//     DBデータ削除は行わない
				if('13' == this.listRkop[this.deleteRecordIndex].recordStatus) {
					
					this.listRkop[this.deleteRecordIndex].sex = '0'
					this.listRkop[this.deleteRecordIndex].stag = 0
					this.listRkop[this.deleteRecordIndex].edag = 0
					this.listRkop[this.deleteRecordIndex].kngk = 0
					this.listRkop[this.deleteRecordIndex].recordStatus = '1'

					this.onConfirmDeleteModalClose()
					return;
				}

				// 非同期通信
				WRKOPApi.Delete({
					token: this.$store.state.auth.token,
					key:   this.$store.state.adminUserChoice.MasterWIRKS.key,
					ircd:  this.$store.state.auth.ircd,
					opbr:  this.listRkop[this.deleteRecordIndex].opbr,
					opcd:  this.listRkop[this.deleteRecordIndex].opcd,
					jkcd:  this.listRkop[this.deleteRecordIndex].jkcd,
					hfkb:  this.hfkb
				}).then(({ responce }) => {

					this.deleteRecordIndex = 0

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// コース毎料金条件リスト再取得
						this.listRkop = responce.data.listRkop
            this.sortListRkop()

						// 削除確認モーダルを閉じる
						this.onConfirmDeleteModalClose()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWRKOP::onDelete End')
				})
			},
			// キャンセル
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWRKOP::onCancel Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WIRKS_BACKTOLIST)

				this.$router.push("/MasterWIRKSList")

				UtilityConsoleLog.consoleLog("MasterWRKOP::onCancel End")
			},
      // listRkopのソート
      sortListRkop: function() {
        UtilityConsoleLog.consoleLog('MasterWRKOP::sortListRkop Start')

        this.listRkop.sort((a, b) => {
          // 同じオプションの場合
          if (a.opbr == b.opbr && a.opcd == b.opcd) {

            //  性別 1:「男性」 2:「女性」 Z:「共通」
            if (a.sex == b.sex) {

              // 性別が同じ場合、年齢範囲のはじめの値が小さい方を優先表示
              return  a.stag > b.stag ? 1 : -1

            //「共通」を優先表示
            } else if (a.sex == 'Z' || b.sex == 'Z') {
              return a.sex != 'Z' && b.sex == 'Z' ? 1 : -1

            // 「男性」優先表示
            } else {
              return a.sex > b.sex ? 1 : -1
            }

          }

          // オプション分類が異なる場合
          if (a.opbr != b.opbr) {
            return a.opbr > b.opbr ? 1 : -1

          // オプション分類が同じかつ、オプションコードが異なる場合
          } else {
            return a.opcd > b.opcd ? 1 : -1
          }
        })

        UtilityConsoleLog.consoleLog('MasterWRKOP::sortListRkop End')
      },
			// オプション分類コード
			getOpbrs: function() {
				UtilityConsoleLog.consoleLog('MasterWRKOP::getOpbrs Start')

				var resultOpbrs = []

				for(var i=0;i<this.listRkop.length;i++){
					resultOpbrs.push(this.listRkop[i].opbr)
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getOpbrs End')

				return resultOpbrs
			},
			// オプション項目コード
			getOpcds: function() {
				UtilityConsoleLog.consoleLog('MasterWRKOP::getOpcds Start')

				var resultOpcds = []

				for(var i=0;i<this.listRkop.length;i++){
					resultOpcds.push(this.listRkop[i].opcd)
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getOpcds End')

				return resultOpcds
			},
			// 現在のjkcdを配列で返す
			getJkcds: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::getJkcds Start')

				var resultJkcds = []

				for(var i=0;i<this.listRkop.length;i++){
					resultJkcds.push(this.listRkop[i].jkcd)
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getJkcds End')

				return resultJkcds
			},
			// 現在のsexを配列で返す
			getSexes: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::getSexes Start')

				var resultSexes = []

				for(var i=0;i<this.listRkop.length;i++){
					resultSexes.push(this.listRkop[i].sex)
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getSexes End')

				return resultSexes
			},
			// 現在のstagを配列で返す
			getStags: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::getStags Start')

				var resultStags = []

				for(var i=0;i<this.listRkop.length;i++){
					resultStags.push(
						this.checkNumber(this.listRkop[i].stag))
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getStags End')

				return resultStags
			},
			// 現在のedagを配列で返す
			getEdags: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::getEdags Start')

				var resultEdags = []

				for(var i=0;i<this.listRkop.length;i++){
					resultEdags.push(
						this.checkNumber(this.listRkop[i].edag))
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getEdags End')

				return resultEdags
			},
			// 現在のkngkを配列で返す
			getKngks: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::getEdags Start')

				var resultKngks = []

				for(var i=0;i<this.listRkop.length;i++){
					resultKngks.push(
						this.checkNumber(this.listRkop[i].kngk))
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getEdags End')

				return resultKngks
			},
			// 現在のrecordStatusを配列で返す
			getRecordStatuses: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::getRecordStatuses Start')

				var resultRecordStatuses = []

				for(var i=0;i<this.listRkop.length;i++){
					resultRecordStatuses.push(this.listRkop[i].recordStatus)
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::getRecordStatuses End')

				return resultRecordStatuses
			},
			// ラジオボタン用　for、name、idに名前割り当て
			getBindName: function(in_for,index){
				return in_for + String(index)
			},
			// レコードに変更があったとき
			changeRecord: function(index) {
				UtilityConsoleLog.consoleLog('MasterWRKOP::changeRecord Start')

				if('0' == this.listRkop[index].recordStatus) {
					this.listRkop[index].recordStatus = '12'
				} else if('1' == this.listRkop[index].recordStatus) {
					this.listRkop[index].recordStatus = '13'
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::changeRecord End')
			},
			// recordStatusによってクラスを設定する
			getClassNameByRecordStatuses: function(index) {
				
				var resultClassName = ''

				if('0' == this.listRkop[index].recordStatus) {
					resultClassName = 'rkopListOn'
				} else if ('1' == this.listRkop[index].recordStatus) {
					resultClassName = 'rkopListOff'
				} else if ('12' == this.listRkop[index].recordStatus
										|| '13' == this.listRkop[index].recordStatus) {
					resultClassName = 'rkopListEdit'
				}

				return resultClassName
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWRKOP::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWRKOP::checkNumber End')

				return tempValue
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onValidationErrorModalOpen Start')

				this.modal.validationError.messages = errorMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onSystemErrorModalOpen Start')

				var messages = [
					'システムエラーです。'
				]

				this.modal.systemError.messages = messages
				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push('/AdminLogin')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmUpdateModalOpen Start')

				// フロント用エラーメッセージ
				var tempErrorMessages = []
				// 入力チェック
				tempErrorMessages = this.validationOnUpdate()

				// 一件でもエラーがあれば入力エラーモーダルウィンドウを開き、処理を中断する
				if( tempErrorMessages.length > 0 ){
					this.onValidationErrorModalOpen(tempErrorMessages)
					return
				}

				var updateMessages = ['更新しますか？']
				this.modal.confirmUpdate.messages = updateMessages
				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmUpdateModalClose End')
			},
			// 削除確認モーダルを開く
			onConfirmDeleteModalOpen: function (index) {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmDeleteModalOpen Start')

				this.deleteRecordIndex = index
				var deleteMessages = ['削除しますか？']
				this.modal.confirmDelete.messages = deleteMessages
				this.modalOpen('confirmDelete')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmDeleteModalOpen End')
			},
			// 削除確認モーダルを閉じる
			onConfirmDeleteModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmDeleteModalClose Start')

				this.deleteRecordIndex = 0
				this.modalClose('confirmDelete')

				UtilityConsoleLog.consoleLog('MasterWRKOP::onConfirmDeleteModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWRKOP::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWRKOP::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWRKOP::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWRKOP::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
			// 更新ボタン押下時（更新ダイアログを開く前）
			validationOnUpdate: function(){

				UtilityConsoleLog.consoleLog('MasterWRKOP::validationOnUpdate Start')

				// フロント用エラーメッセージ
				var resultErrorMessages = []

				// 年齢範囲開始の数値チェック
				for(var i=0;i<this.listRkop.length;i++){
					var tempStag = this.checkNumber(this.listRkop[i].stag)
					if (tempStag == -1) {
						resultErrorMessages.push( String(i + 1) + '行目の年齢範囲開始は整数値で入力してください。')
					}
				}

				// 年齢範囲終了の数値チェック
				for(var i=0;i<this.listRkop.length;i++){
					var tempEdag = this.checkNumber(this.listRkop[i].edag)
					if (tempEdag == -1) {
						resultErrorMessages.push( String(i + 1) + '行目の年齢範囲終了は整数値で入力してください。')
					}
				}

				// 合計金額の数値チェック
				for(var i=0;i<this.listRkop.length;i++){
					var tempKngk= this.checkNumber(this.listRkop[i].kngk)
					if (tempKngk == -1) {
						resultErrorMessages.push( String(i + 1) + '行目の合計金額は整数値で入力してください。')
					}
				}

        // 同一オプション内での年齢範囲のチェック
        for(var i=0;i<this.listRkop.length;i++){
          let checkOpbr = this.listRkop[i].opbr
          let checkOpcd = this.listRkop[i].opcd
          let checkSex = this.listRkop[i].sex
          let checkStag = this.listRkop[i].stag
          let checkEdag = this.listRkop[i].edag
          let ageRange = (a, b, num) => (Math.min(a, b) <= num && num < Math.max(a, b))
          let invalidResult = this.listRkop.some((record, index) => {
            // 同じindexのものはスキップ
            if (index == i) {
              return false
            }
            // オプション分類、オプションコード、性別のチェック
            if (record.opbr == checkOpbr && record.opcd == checkOpcd && (record.sex == checkSex || record.sex == 'Z' || checkSex == 'Z')) {
              // 年齢範囲が範囲内かどうかチェック
              if (ageRange(checkStag, checkEdag, record.stag) || ageRange(checkStag, checkEdag, record.edag) || ageRange(record.stag, record.edag, checkStag) || ageRange(record.stag, record.edag, checkEdag)) {
                UtilityConsoleLog.consoleLog('MasterWRKOP::validationOnUpdate invalid data')
                return true
              }
            }
          })

          // エラー対象がある場合
          if (invalidResult) {
            resultErrorMessages.push( String(i + 1) + '行目のオプションで性別、年齢範囲が適切ではありません。')
          }
        }

				UtilityConsoleLog.consoleLog('MasterWRKOP::validationOnUpdate End')

				return resultErrorMessages
			}
		}
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKS/MasterWRKOP.vue